export interface Pixel {
    client_name: string,
    client_domain: string,
    pixel_id: string,
    created_at: string,
    updated_at: string
}

export interface PixelGeneratorFormInputs {
    clientName?: string,
    clientDomain?: string,
    pixelId?: string,
    createdAt?: string
}

export interface PixelTagsType {
    htmlGeneralTags: string,
    htmlLandingPageTags: string,
    htmlHomePageTags: string,
    htmlOtherTags: string,
    htmlTrackConversionTags: string
}

export interface PixelExportType {
    existingPixels: Pixel[],
    isSelected: Function,
    handleRowClick: Function
}

export const defaultPixelGeneratorFormInputValues:PixelGeneratorFormInputs = {
    clientName: '',
    clientDomain: '',
    pixelId: '',
    createdAt: undefined
};
